import * as styledSystem from 'styled-system';
import themeGet from '@styled-system/theme-get';
import theme from './index';
var getKey = styledSystem.get;
export var getTheme = function getTheme(key) {
  return themeGet(key, getKey(theme, key));
};